import ShowLegalConditionsPopup from "@/pages/ShowLegalConditionsPopup/ShowLegalConditionsPopup";
import "./Footer.scss";

import { useLanguage } from "@/iti-core-react/hooks/useLanguage";
import { InformativeCondition } from "@/shared/enums/Centralized/informative-condition";
import { useCallback, useState } from "react";

export default function Footer({ ...rest }: React.HTMLAttributes<HTMLElement>) {
	const [showPopup, setShowPopup] = useState(false);
	const [selectedConditionId, setSelectedConditionId] = useState<string | null>(
		null,
	);
	const { t } = useLanguage();

	const handleOpenPopup = useCallback((conditionId: InformativeCondition) => {
		setSelectedConditionId(conditionId);
		setShowPopup(true);
	}, []);

	const handleHideLegalPopup = useCallback(() => {
		setShowPopup(false);
		setSelectedConditionId(null);
	}, []);

	const makeKeyHandler = useCallback(
		(conditionId: InformativeCondition) =>
			(event: React.KeyboardEvent<HTMLButtonElement>) => {
				if (event.key === "Enter" || event.key === " ") {
					event.preventDefault();
					handleOpenPopup(conditionId);
				}
			},
		[handleOpenPopup],
	);

	return (
		<footer className="footer" {...rest}>
			<span
				onClick={() => handleOpenPopup(InformativeCondition.PRIVACY_COOKIES)}
				onKeyDown={makeKeyHandler(InformativeCondition.PRIVACY_COOKIES)}
				className="hoverable"
			>
				{t("footer.privacy-cookies")}
			</span>

			<span className="separator"> - </span>

			<span
				onClick={() => handleOpenPopup(InformativeCondition.LEGAL_NOTICE)}
				onKeyDown={makeKeyHandler(InformativeCondition.LEGAL_NOTICE)}
				className="hoverable"
			>
				{t("footer.legal-notice")}
			</span>

			<span className="separator"> - </span>
			<span className="year">2025 ©</span>
			<span className="separator"> - </span>
			<span className="version">{import.meta.env.VITE_VERSION}</span>

			{showPopup && selectedConditionId && (
				<ShowLegalConditionsPopup
					conditionClauseId={selectedConditionId}
					onHide={handleHideLegalPopup}
				/>
			)}
		</footer>
	);
}
